<template>
    <BaseTooltip v-if="isConverted"
        :label="conversionDescription"
        is-small
        allow-line-breaks
        dashed
        append-to-body
    >
        <span>
            {{amount}}
        </span>
        <!-- 
            This doesn't work until Buefy 0.9+ :(
            <template #content>
            <div>
                {{`${money.Original.Formatted} = ${money.Formatted}`}}<br />
                {{`1.00 ${money.Original.CurrencyType.Suffix} = ${money.Rate} on ${money.RateDate}`}};
            </div>
        </template> -->
    </BaseTooltip>
    <span v-else>
        {{amount}}
    </span>
</template>

<script>
export default {
    props:{
        /* 
            Money is an instance of CurrencyModel.money
            or CurrencyModel.ConvertedMoney. money properties
            should be read from computeds
        */
        money: {
            type: Object,
            required: true
        },

        // preference to show the money.Original currency
        original: Boolean,

        // preference to show the unformatted (Money.Value) amount
        raw: Boolean
    },
    computed:{
        isConverted(){
            return this.money.IsConverted;
        },
        conversionDescription(){
            /*  
                Example tooltip text:
                4,500.00 EUR = 5,304.47 USD
                (1.00 EUR = 1.17877 USD on 10/6/2020)
            */ 
            const {money} = this;

            // original = converted
            return `${money.Original.Formatted} = ${money.Formatted}\n1.00 ${money.Original.CurrencyType.Suffix} = ${money.Rate} ${money.CurrencyType.Suffix} on ${money.RateDate}`.trim();
        },
        format(){
            return this.raw ? 'Value' : 'Formatted';
        },
        amount(){
            let {money} = this;
            if (this.original) {
                money = this.money.Original;
            }

            return money[this.format];
        }
    }
};
</script>